module.exports = __webpack_public_path__ + "img/motion_login.18d67b2f.png";